// extracted by mini-css-extract-plugin
module.exports = {"donation":"lN","donationIcon":"lO","donationTitle":"lP"};